const BLACK = 'black';
const GREY = 'grey';
const RED = 'red';
const WHITE = 'white';

export {BLACK, GREY, RED, WHITE};